import React, { useState } from "react"
import { graphql, Link } from "gatsby"
import SEO from "../components/seo"
import styles from "../styles/about.module.scss"

import Layout from "../components/layout"

import aboutTeam from "../images/delete/about-team1.jpg"
import promise from "../images/delete/about-team2.jpg"
import motivation from "../images/delete/about-team3.jpg"
import ourTeam from "../images/delete/about-team4.jpg"

import medicalIcon from "../images/delete/medical-icon.svg"
import mountainsIcon from "../images/delete/mountains-icon.svg"
import pinIcon from "../images/delete/pin-icon.svg"
import pizzaIcon from "../images/delete/pizza-icon.svg"
import basketballIcon from "../images/delete/basketball-icon.svg"
import heartIcon from "../images/delete/heart-icon.svg"
import chevronDown from "../images/delete/positions-chevron-icon.svg"

export const query = graphql`
  query ABOUT {
    wpgraphql {
      about: corePageBy(corePageId: 7270) {
        seo {
          metaDesc
          title
          twitterTitle
          twitterDescription
          opengraphTitle
          opengraphDescription
        }
      }
    }
  }
`

const About = ({ data }) => {
  const [firstBlock, setFirstBlock] = useState(false)
  const [secondBlock, setSecondBlock] = useState(false)
  const [thirdBlock, setThirdBlock] = useState(false)
  const seo = data.wpgraphql.about.seo

  const handleFirstBlock = () => {
    setFirstBlock(!firstBlock)
  }
  const handleSecondBlock = () => {
    setSecondBlock(!secondBlock)
  }
  const handleThirdBlock = () => {
    setThirdBlock(!thirdBlock)
  }

  return (
    <Layout>
      <SEO {...seo} />
      <div className={styles.hero}>
        <div className={styles.container}>
          <h1>
            We’re driven to provide the conferencing solutions you can count on
            every single day.
          </h1>
        </div>
      </div>
      <section className={styles.aboutFocus}>
        <div className={styles.focusContainer}>
          <div className={`${styles.focusExcerpt} ${styles.aboutExcerpt}`}>
            <h4>Our Focus</h4>
            <h2>
              For over a decade, our sole motivation has been to deliver the
              highest quality audio, online meeting and video conferencing
              service available.
            </h2>
            <p>
              We’ve created a platform that is affordable for small businesses
              and solo entrepreneurs, while powerful enough to meet the needs of
              the largest enterprise organizations.
            </p>
            <p>
              In 2008, Vast Conference was founded with the belief that our team
              should and could build the most cutting-edge and trusted
              conferencing technology on the market. Since then, we have been
              providing innovative and scalable conferencing services to
              businesses of every size and stage of their growth.
            </p>
          </div>
          <div className={styles.focusCreativeContainer}>
            <div className={`${styles.featureOne} ${styles.aboutFeature}`}>
              <Link to="/online-meetings">
                <h4>Online Meetings</h4>
              </Link>
              <p>
                All the features you need to get work done: present, share,
                record, chat and more.
              </p>
            </div>
            <img src={aboutTeam} alt="focus creative" />
          </div>
        </div>
      </section>

      <section className={styles.aboutPromise}>
        <div className={styles.promiseContainer}>
          <div className={styles.promiseCreativeContainer}>
            <div className={`${styles.featureTwo} ${styles.aboutFeature}`}>
              <Link to="/conference-call-services">
                <h4>Conference Calling</h4>
              </Link>
              <p>
                Host calls instantly or schedule meetings in advance with your
                dedicated dial-in
              </p>
            </div>
            <div className={styles.promiseImage}>
              <img src={promise} alt="promise creative" />
            </div>
          </div>
          <div className={`${styles.proiseText} ${styles.aboutExcerpt}`}>
            <h4>Our Promise of Reliability</h4>
            <h2>
              Our technology makes your communications needs worry free -
              allowing you to connect worldwide with industry colleagues,
              investors, customers, and business partners without limitation.
            </h2>
          </div>
        </div>
      </section>

      <section className={styles.aboutMotivation}>
        <div className={styles.motivationContainer}>
          <div className={`${styles.motivationText} ${styles.aboutExcerpt}`}>
            <h4>Our Motivation</h4>
            <h2>
              The power of potential is what drives us. We consistently strive
              to enhance our communications platform and conferencing service
              offerings to empower our customers and support their business.
            </h2>
          </div>

          <div className={styles.motivationCreativeContainer}>
            <div className={`${styles.featureThree} ${styles.aboutFeature}`}>
              <Link to="/video-conferencing">
                <h4>Video Conferencing</h4>
              </Link>
              <p>
                Truly connect with a real-time, face-to-face connection, online.
              </p>
            </div>
            <div className={styles.motivationImage}>
              <img src={motivation} alt="motivation photo" />
            </div>
          </div>
        </div>
      </section>

      <section className={styles.aboutTeam}>
        <div className={styles.teamContainer}>
          <div className={styles.teamCreativeContainer}>
            <div className={`${styles.featureFour} ${styles.aboutFeature}`}>
              <Link to="/operator-assisted-call">
                <h4>Operator-Assisted Calls</h4>
              </Link>
              <p>
                Specially-trained, professional management for your most
                critical events.
              </p>
            </div>
            <div className={styles.teamImage}>
              <img src={ourTeam} alt="our team photo" />
            </div>
          </div>
          <div className={`${styles.teamText} ${styles.aboutExcerpt}`}>
            <h4>Our Team</h4>
            <h2>
              Our value depends on our customer’s happiness. We pride ourselves
              on client service and will be there to support your business
              success.
            </h2>
          </div>
        </div>
      </section>

      <div className={styles.benefitsContainer}>
        <div className={styles.container}>
          <div className={styles.textContainer}>
            <h2>Our Benefits</h2>
            <p className={styles.subtext}>
              Join our team as we continue grow. We’re looking for talented,
              engaging people to add to our mix. Come down to El Segundo, CA.
              We’d love to meet you.
            </p>
          </div>
          <div className={styles.benefitFeatures}>
            {/* BOX */}
            <div className={styles.benefit}>
              <div className={styles.titleContainer}>
                <span className={styles.icon}>
                  <img src={medicalIcon} alt="benefit icon" />
                </span>
                <span className={styles.title}>Full Medical</span>
              </div>
              <p>
                Be confident with full medical coverage and know you can get the
                care you need.
              </p>
            </div>

            {/* BOX */}
            <div className={styles.benefit}>
              <div className={styles.titleContainer}>
                <span className={styles.icon}>
                  <img src={mountainsIcon} alt="benefit icon" />
                </span>
                <span className={styles.title}>Paid Vacation</span>
              </div>
              <p>
                Paid vacation time is provided to all employees from the day
                they start.
              </p>
            </div>

            {/* BOX */}
            <div className={styles.benefit}>
              <div className={styles.titleContainer}>
                <span className={styles.icon}>
                  <img src={pinIcon} alt="benefit icon" />
                </span>
                <span className={styles.title}>Office in Sunny LA</span>
              </div>
              <p>
                70 and sunny isn’t an exaggeration – we get to enjoy it every
                day and you can too.
              </p>
            </div>

            {/* BOX */}
            <div className={styles.benefit}>
              <div className={styles.titleContainer}>
                <span className={styles.icon}>
                  <img src={pizzaIcon} alt="benefit icon" />
                </span>
                <span className={styles.title}>Snacks and Drinks</span>
              </div>
              <p>
                Enjoy complimentary snacks & drinks in our offices for whenever
                you need a bite.
              </p>
            </div>

            {/* BOX */}
            <div className={styles.benefit}>
              <div className={styles.titleContainer}>
                <span className={styles.icon}>
                  <img src={basketballIcon} alt="benefit icon" />
                </span>
                <span className={styles.title}>Company Outings</span>
              </div>
              <p>
                Now and then we meet outside the office for fun or giving back
                to the community.
              </p>
            </div>

            {/* BOX */}
            <div className={styles.benefit}>
              <div className={styles.titleContainer}>
                <span className={styles.icon}>
                  <img src={heartIcon} alt="benefit icon" />
                </span>
                <span className={styles.title}>Casual Dress</span>
              </div>
              <p>
                No formal business attire – dress is casual so you can be
                comfortable as you are.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.openPositionsSection}>
        <div className={styles.container}>
          <h2>Open Positions</h2>

          {/* POSITION */}
          <div className={styles.position} onClick={handleFirstBlock}>
            <div className={styles.header}>
              <div className={styles.textContainer}>
                <div className={styles.titleChevronContainer}>
                  <div className={styles.chevron}>
                    <img src={chevronDown} alt="chevron icon" />
                  </div>
                  <div className={styles.titleContainer}>
                    <div className={styles.title}>
                      Inside Sales Representative & Accounts Manager
                    </div>
                    <div className={styles.department}>
                      Communications, Public Relations
                    </div>
                  </div>
                </div>
              </div>
              <Link
                to="/contact"
                onClick={e => e.stopPropagation()}
                className={styles.apply}
              >
                APPLY NOW
              </Link>
            </div>

            <div
              className={`${styles.informationContainer} ${firstBlock &&
                styles.show}`}
            >
              <div>
                <p>
                  We are currently seeking an Inside Sales Representative and
                  Accounts Manager with a strong inside sales or retail
                  background and an enthusiastic and engaging personality. This
                  full-time position will require strong communication skills,
                  both written and verbal, and a dedication to measurable
                  results. As an Inside Sales Representative, you will be
                  interacting with current clients while answering questions and
                  outlining key product benefits to prospective customers
                  generated from inbound marketing efforts.
                </p>

                <p>
                  You will proactively develop relationships with customers with
                  the goal of closing sales and generating product revenue. If
                  you have the requisite sales experience with a track record of
                  success, proven communication & organizational skills, and
                  love to win – we want to talk to you.
                </p>
              </div>

              <div>
                <h4>Responsibilities</h4>
                <ul>
                  <li>
                    Interact with prospective business customers and current
                    clients
                  </li>
                  <li>
                    Understand the client’s needs & effectively communicate how
                    Vast will meet them
                  </li>
                  <li>
                    Match use cases to the best Vast Conference service offering
                  </li>
                  <li>
                    Document qualification details including use case, purchase
                    timeframes & next steps
                  </li>
                  <li>
                    Close and manage the onboarding transition with our Customer
                    Service team
                  </li>
                </ul>
              </div>

              <div>
                <h4>Qualifications</h4>
                <ul>
                  <li>
                    At least 1-2 years of professional inside sales or retail
                    experience (software sales a plus)
                  </li>
                  <li>Excellent communication skills (written and verbal)</li>
                  <li>
                    Ability to learn the service and train clients on technology
                    and product usage
                  </li>
                  <li>Highly organized with exceptional follow up skills</li>
                  <li>
                    Ability to quickly build rapport and gain trust over the
                    phone
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* POSITION */}
          <div className={styles.position} onClick={handleSecondBlock}>
            <div className={styles.header}>
              <div className={styles.textContainer}>
                <div className={styles.titleChevronContainer}>
                  <div className={styles.chevron}>
                    <img src={chevronDown} alt="chevron icon" />
                  </div>
                  <div className={styles.titleContainer}>
                    <div className={styles.title}>
                      Customer Success Representative
                    </div>
                    <div className={styles.department}>
                      Communications, Public Relations
                    </div>
                  </div>
                </div>
              </div>
              <Link
                to="/contact"
                onClick={e => e.stopPropagation()}
                className={styles.apply}
              >
                APPLY NOW
              </Link>
            </div>

            <div
              className={`${styles.informationContainer} ${secondBlock &&
                styles.show}`}
            >
              <div>
                <p>
                  We are looking for a Customer Success Representative who
                  understands the value of nurturing customer relationships and
                  helping people. You will be responsible for interacting with
                  new customers during their onboarding process to drive user
                  adoption and satisfaction to ensure high client retention.
                </p>

                <p>
                  In this full-time role, you will work with new and existing
                  customers to ensure their initial success and happiness with
                  our conferencing services. It is your responsibility to
                  effectively onboard new accounts, encourage initial use with
                  high customer satisfaction. You will manage support emails and
                  phone calls, follow up on existing issues, provide customer
                  insights and feedback to product marketing and engineering to
                  help Vast Conference provide the best product possible.
                </p>
              </div>

              <div>
                <h4>Responsibilities</h4>
                <ul>
                  <li>Provide amazing support to Vast Conference customers</li>
                  <li>
                    Resolve inbound requests via phone, email and online chat
                    along with other tools
                  </li>
                  <li>
                    Be both support representative and sales consultant for a
                    variety of features and services
                  </li>
                  <li>
                    Speak to users about technical issues in a way they can
                    understand
                  </li>
                  <li>
                    Collect and report on customer feedback to product team
                  </li>
                </ul>
              </div>

              <div>
                <h4>Qualifications</h4>
                <ul>
                  <li>
                    1+ year experience in customer service, call center, or
                    retail sales role
                  </li>
                  <li>Bachelor’s degree preferred</li>
                  <li>Excellent customer service skills</li>
                  <li>Strong written and verbal communication skills</li>
                  <li>Well organized and able to multi-task</li>
                  <li>Able to work independently and as a team player</li>
                  <li>
                    Maintain a positive attitude, strong work ethic and empathy
                    for new users
                  </li>
                  <li>
                    Must be available to work Monday to Friday 7:00 AM – 4:00 PM
                    PST
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* POSITION */}
          <div className={styles.position} onClick={handleThirdBlock}>
            <div className={styles.header}>
              <div className={styles.textContainer}>
                <div className={styles.titleChevronContainer}>
                  <div className={styles.chevron}>
                    <img src={chevronDown} alt="chevron icon" />
                  </div>
                  <div className={styles.titleContainer}>
                    <div className={styles.title}>Marketing Assistant</div>
                    <div className={styles.department}>
                      Communications, Public Relations
                    </div>
                  </div>
                </div>
              </div>
              <Link
                to="/contact"
                onClick={e => e.stopPropagation()}
                className={styles.apply}
              >
                APPLY NOW
              </Link>
            </div>

            <div
              className={`${styles.informationContainer} ${thirdBlock &&
                styles.show}`}
            >
              <div>
                <p>
                  Seeking a Marketing Assistant who can support our Marketing
                  Communications Manager develop and execute a variety of
                  creative and promotional programs. The Marketing Assistant
                  will help create and maintain sales materials, marketing and
                  social media campaigns. They will help coordinate project
                  activities and participate in research efforts to help with
                  the growth of the company.
                </p>
              </div>

              <div>
                <h4>Responsibilities</h4>
                <ul>
                  <li>
                    Work under the supervision of the Marketing Communications
                    Manager to develop and execute strategies for the growth of
                    the company
                  </li>
                  <li>
                    Do research to understand customer needs and how content can
                    address them
                  </li>
                  <li>
                    Perform competitive analysis to uncover content gaps and
                    opportunities
                  </li>
                  <li>
                    Assist in designing and developing marketing collaterals and
                    promotional materials
                  </li>
                  <li>
                    Contribute written content for website, blog and social
                    media
                  </li>
                  <li>
                    Recommend creative and cost-effective promotional activities
                  </li>
                </ul>
                <h4>The Marketing Assistant has:</h4>
                <ul>
                  <li>Knowledge of WordPress</li>
                  <li>Basic understanding of HTML and web publishing</li>
                  <li>Familiarity with SEO best practices</li>
                  <li>
                    An ability to manage multiple projects and meet deadlines.
                  </li>
                </ul>
              </div>

              <div>
                <h4>Qualifications</h4>
                <ul>
                  <li>Provide amazing support to Vast Conference customers</li>
                  <li>
                    Resolve inbound requests via phone, email and online chat
                    along with other tools
                  </li>
                  <li>
                    Be both support representative and sales consultant for a
                    variety of features and services
                  </li>
                  <li>
                    Speak to users about technical issues in a way they can
                    understand
                  </li>
                  <li>
                    Collect and report on customer feedback to product team
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default About
